import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

export const ROUTE_BEFORE_LOGIN_KEY = 'routeBeforeLogin';

export function storeRouteBeforeLogin(route: string): void {
    localStorage.setItem(ROUTE_BEFORE_LOGIN_KEY, JSON.stringify({ url: route }));
}

@Injectable()
export class StateManagementService {
    private readonly ROUTE_BEFORE_LOGIN = ROUTE_BEFORE_LOGIN_KEY;

    constructor(private router: Router){}

    getRouteBeforeLogin(): string | null {
        const storedRoute = localStorage.getItem(this.ROUTE_BEFORE_LOGIN);
        if (!storedRoute) {
            return null;
        }

        try {
            const route = JSON.parse(storedRoute)?.url;
            if (typeof route === 'string' && route.startsWith('/') && !route.startsWith('//') && !/^\/(signin|signout)(?=[/?#]|$)/i.test(route)) {
                return route;
            }
        } catch (error) {
            console.error('Unable to read the route saved before login.', error);
        }

        localStorage.removeItem(this.ROUTE_BEFORE_LOGIN);
        return null;
    }

    storeRouteBeforeLogin(route: string): void {
        storeRouteBeforeLogin(route);
    }

    clearRouteBeforeLogin(): void {
        localStorage.removeItem(this.ROUTE_BEFORE_LOGIN);
    }

    postLoginRedirect(): void {
        const route = this.getRouteBeforeLogin();
        this.clearRouteBeforeLogin();

        void this.router.navigateByUrl(route || '/', { replaceUrl: true });
    }
}
